<div class="backdrop"></div>
<div class="popup-standard limit-width-on-desktop-float">
  <ng-content></ng-content>
</div>
